let authGroups = require('../auth');
let utils = require('../../../actions/utils');
let cookie = require('../../../actions/cookie');
let user = require('../../../actions/user');
let analytics = require('../../../actions/analytics');

module.exports = {
    loginSuccess: [
        utils.set(['page', 'name'], 'alert'),
        utils.set(['auth', 'alert', 'type'], 'loginSuccess'),
        analytics.argsValueEvent({ category: 'post_successful_authorization', action: 'see' }),
        cookie.setSessionToken,
        user.addUserRole,
        utils.setFromArgsToState('extendedUser', 'user'),
        ...authGroups.createOrderAfterLoginIfNeededOrRedirect
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/auth/login.js